import { useMutation } from '@apollo/client';
import { PATCH_LEARNING_OBJECT_MUTATION } from '../../mutations';

export function usePatchLearningObjectMutation() {
    return useMutation( PATCH_LEARNING_OBJECT_MUTATION );
}
